import SupervisorDropdown from '../../components/CommonForBoth/TopbarDropdown/SupervisorDropdown';
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  FormFeedback,
  Label,
  Input
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from "react-select";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import Snackbars from "../../Utils/Snackbars";
import useRequests from "../../Utils/useRequests";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import moment from 'moment';

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Jha = props => {
  const [modal_Delete_JHA, setmodal_Delete_JHA] = useState(false);
  function Delete_JHA(jha_id) {
    setDeleteJHAId(jha_id);
    setmodal_Delete_JHA(!modal_Delete_JHA);
  }

  //meta title
  document.title = "JHA";
  const location = useLocation();
  const { getRequest, postRequest } = useRequests();

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };

  const [deleteJHAId, setDeleteJHAId] = useState(null);
  const handleDeleteJHA = async () => {
    try {
      const jsonpar = JSON.stringify({ jha_id: deleteJHAId });
      const res = await postRequest('delete-jha', jsonpar);

      if (res && res.code === 200) {
        setAlertData({
          variant: 'success',
          message: res.message,
        });
        setDeleteJHAId(null);
        handleLoadGetJHA();
      } else {
        setAlertData({
          variant: 'error',
          message: res.message || 'Failed to delete jha',
        });
      }
    } catch (error) {
      console.error("Delete Error:", error);
      setAlertData({
        variant: 'error',
        message: 'Something went wrong while deleting jha',
      });
    }
    resetAlertData();
    setmodal_Delete_JHA(false);
  };

  const [commentsError, setCommentsError] = useState("");

  const [StandardModal, setStandardModal] = React.useState(false);
  const [comments, setComments] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);

  const togStandardModal = async (elementData) => {
    validation.setValues({
      ...validation.values,
      jha_id: elementData.jha_id,
    });
    setStandardModal(true);
  }

  // Open modal for changing status
  const [statusModal, setStatusModal] = useState(false);
  const [selectedJhaId, setSelectedJhaId] = useState(null);
  const openStatusModal = (jha_id) => {
    setSelectedJhaId(jha_id);
    setComments("");
    setStatusModal(true);
  };

  const handleChangeStatus = async (status) => {
    if (!comments.trim()) {
      setCommentsError("Comments are required before approving or rejecting JHA");
      return;
    }

    try {
      const jsonData = JSON.stringify({
        jha_id: selectedJhaId,
        status: status,
        comments: comments,
      });

      const res = await postRequest("update-jha-status", jsonData);

      if (res && res.code === 200) {
        handleLoadGetJHA(); // Refresh table data
        setAlertData({ variant: "success", message: "Updated JHA status successfully" });
        setStatusModal(false);
        resetAlertData();
        setComments("");
        setCommentsError("");
      } else {
        setAlertData({ variant: "error", message: "Failed to update JHA status" });
        setStatusModal(false);
        resetAlertData();
        setCommentsError(res.message || "Failed to update JHA status");
      }
    } catch (error) {
      console.error("Status Update Error:", error);
      setCommentsError("Something went wrong while updating JHA status");
    }
  };

  const [JHAData, setJHAData] = React.useState([]);
  const [JHATBody, setJHATBody] = React.useState('');

  const [searchTerm, setSearchTerm] = useState(""); // <-- Added for search
  const [filteredData, setFilteredData] = useState([]); // <-- Added for search

  // Download PDF handler with loading state
  const [downloadingJhaId, setDownloadingJhaId] = useState(null);
  const handleDownloadJhaPdf = async (jha_id) => {
    setDownloadingJhaId(jha_id);
    try {
      const jsonpar = JSON.stringify({ jha_id });
      const res = await postRequest('preview-jha-pdf', jsonpar);
      if (res && res.code === 200 && res.data) {
        // Create a temporary link to download the PDF
        const link = document.createElement('a');
        link.href = res.data;
        link.target = '_blank';
        link.download = `jha_${jha_id}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setAlertData({ variant: 'error', message: res.message || 'Failed to get PDF link' });
        resetAlertData();
      }
    } catch (error) {
      setAlertData({ variant: 'error', message: 'Error downloading PDF' });
      resetAlertData();
    } finally {
      setDownloadingJhaId(null);
    }
  };

  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.organization_name}</td>
        <td>{element.foremen_first_name+" "+element.foremen_last_name}</td>
        <td>{element.job_number}</td>
        <td>{element.contract_type}</td>
        <td>{element.job_type}</td>
        <td>{element.company_name}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td>
          <i
            className="bx bxs-file-pdf"
            style={{ fontSize: "20px", cursor: "pointer", marginRight: "8px" }}
            title="Download PDF"
            onClick={() => handleDownloadJhaPdf(element.jha_id)}
          ></i>
          {element.jha_status=="Completed"?"Completed":"Pending"}
        </td>
        {/* ...existing code... */}
      </tr>
    ));

    setJHATBody(tempTBody);
  }

  const handleLoadGetJHA = async () => {
    const jsonpar = JSON.stringify({
      selected_organization: localStorage.getItem('SELECTED_SUPERVISOR_ID')
    });
    const res = await postRequest('get-jha', jsonpar);
    if (res && res.code === 200) {
      let originalText = res.data;
      const jhafilteredData = originalText.filter(item => item.lang == localStorage.getItem("I18N_LANGUAGE"));

      setJHAData(jhafilteredData);
      setFilteredData(jhafilteredData); // <-- keep filtered data in sync
      handleT1Body(jhafilteredData);
    }
    else {
      let tempTBody = (<tr>
        <td colSpan="9" className="text-center">No records found</td>
      </tr>);

      setJHATBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  const [supervisors, setSupervisors] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState({ a_id: 'all', name: 'All Organizations' });
  const fetchSupervisors = async () => {
      const res = await getRequest('get-organization');
      if (res && res.code === 200 && Array.isArray(res.data)) {
        setSupervisors(res.data);
        // Set default from localStorage if exists
        const stored = localStorage.getItem('SELECTED_SUPERVISOR_ID');
        if (stored) {
          if (stored === 'all') {
            setSelectedSupervisor({ a_id: 'all', name: 'All Organizations' });
          } else {
            const found = res.data.find(s => String(s.a_id) === String(stored));
            if (found) setSelectedSupervisor(found);
          }
        } else {
          setSelectedSupervisor({ a_id: 'all', name: 'All Organizations' });
          localStorage.setItem('SELECTED_SUPERVISOR_ID', 'all');
        }
      }
    };
    
  // Filter table data based on search term
  useEffect(() => {
    fetchSupervisors();

    if (!searchTerm) {
      setFilteredData(JHAData);
      return;
    }
    const lowerSearch = searchTerm.toLowerCase();
    const filtered = JHAData.filter((element) =>

      element.organization_name?.toLowerCase().includes(lowerSearch) ||
      (element.foremen_first_name+" "+element.foremen_last_name)?.toLowerCase().includes(lowerSearch) ||
      element.company_name?.toLowerCase().includes(lowerSearch) ||
      element.contract_type?.toLowerCase().includes(lowerSearch) ||
      element.job_number?.toLowerCase().includes(lowerSearch) ||
      element.job_type?.toLowerCase().includes(lowerSearch) ||
      moment(element.created_at).format('YYYY-MM-DD').includes(lowerSearch)
    );
    setFilteredData(filtered);
  }, [searchTerm, JHAData]);

  useEffect(() => {
    handleLoadGetJHA();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
    }
  }, []);

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
       
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("JHA")} />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                {/* Organization Dropdown */}
                <div className="mb-3 d-flex justify-content-end">
                  <SupervisorDropdown />
                </div>
                  {/* 🔍 Search Box */}
                  <div className="mb-3">
                    <Input
                      type="text"
                      placeholder="Search by Company, Contract, Job Number, Job Type, or Date"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  <div className="table-rep-plugin">
                    <div className="table-responsive mb-0">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1000px' }}>
                        <thead>
                          <tr>
                            <th style={{ width: '200px' }}>Organization</th>
                            <th style={{ width: '200px' }}>Foremen</th>
                            <th style={{ width: '200px' }}>Job Number</th>
                            <th style={{ width: '200px' }}>Contract type</th>
                            <th style={{ width: '200px' }}>Job Type</th>
                            <th style={{ width: '200px' }}>Company Name</th>
                            <th style={{ width: '200px' }}>Date</th>
                            <th style={{ width: '200px' }}>Status</th>
                            <th style={{ width: '120px' }}>PDF</th>
                            {/* <th className="text-center">Actions</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData.length > 0 ? (
                            filteredData.map((element, index) => (
                              <tr key={index}>
                                <td>{element.organization_name}</td>
                                <td>{element.foremen_first_name+" "+element.foremen_last_name}</td>
                                <td>{element.job_number}</td>
                                <td>{element.contract_type}</td>
                                <td>{element.job_type}</td>
                                <td>{element.company_name}</td>
                                <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
                                <td>
                                  {element.jha_status=="Completed"?"Completed":"Pending"}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    style={{ minWidth: 40, position: 'relative', padding: '1px 6px', fontSize: '0.75rem', lineHeight: '1.1', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                    disabled={downloadingJhaId === element.jha_id}
                                    onClick={() => handleDownloadJhaPdf(element.jha_id)}
                                  >
                                    {downloadingJhaId === element.jha_id ? (
                                      <>
                                        Downloading...
                                      </>
                                    ) : (
                                      <>
                                        Download
                                      </>
                                    )}
                                  </button>
                                </td>
                                {/* <td className="text-center">
                                  <div className="centerLink">
                                    <Link title="View JHA" to={"#"} className="font-size-14 bg-primary edit-box"><i className="bx bxs-show"></i></Link>
                                    {element.jha_status === "pending" && (
                                      <Link
                                        title="Approve/Reject JHA"
                                        to={"#"}
                                        onClick={() => openStatusModal(element.jha_id)}
                                        className="font-size-14 bg-success edit-box"
                                      >
                                        <i className="bx bx-check-circle"></i>
                                      </Link>
                                    )}
                                  </div>
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">No matching records found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* <div className="infoIcon">
                      <div className="infoIconBox">
                        <i className="bx bxs-show"></i>
                        <p>View JHA</p>
                      </div>
                      <div className="infoIconBox">
                        <i className="bx bx-check-circle"></i>
                        <p>Approve/Reject JHA</p>
                      </div>
                    </div> */}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modal_Delete_JHA} toggle={() => { Delete_JHA(); }} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Delete JHA</h5>
            <button type="button" onClick={() => { setmodal_Delete_JHA(false); }} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <p>Are you sure you wan't to delete this jha?</p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="primary" onClick={handleDeleteJHA} >Delete</Button>
            <Button type="button" color="light" onClick={() => { setmodal_Delete_JHA(false); }} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>

      {/* Status Change Modal */}
      <Modal isOpen={statusModal} toggle={() => setStatusModal(false)}>
        <div className="modal-header">
          <h5 className="modal-title">Approve / Reject JHA</h5>
          <button type="button" className="btn-close" onClick={() => setStatusModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label htmlFor="comments" className="form-label">Comments <span className="text-danger">*</span></label>
            <textarea
              id="comments"
              className={`form-control ${commentsError ? "is-invalid" : ""}`}
              rows="3"
              value={comments}
              onChange={(e) => {
                setComments(e.target.value);
                setCommentsError("");
              }}
              placeholder="Enter comments here..."
            ></textarea>
            {commentsError && <div className="invalid-feedback">{commentsError}</div>}
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-success"
            onClick={() => handleChangeStatus("Completed")}
          >
            Completed
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleChangeStatus("Rejected")}
          >
            Rejected
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(Jha);
